const comments = [
  {
    name: '光影猎人',
    text: '一直在找能稳定高清看电影的网站，68影院真的太良心了！热门电影排行榜更新超快，片库也非常全，现在每天必刷。',
    time: '2 小时前',
    avatar: 'ri-user-3-fill',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    name: '周末影迷',
    text: '周末宅家必备！悬疑片分类索引太方便了，找到好几部之前一直想看的悬疑烧脑片，高清画质在线看不缓冲，体验一级棒。',
    time: '5 小时前',
    avatar: 'ri-user-3-fill',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    name: '科幻控本人',
    text: '科幻迷狂喜！《星际迷航：新纪元》刚上线就有了，而且画质是真的高清，比某些平台还清楚。已推荐给身边所有朋友。',
    time: '8 小时前',
    avatar: 'ri-user-3-fill',
    color: 'bg-secondary-100 text-secondary-600',
  },
  {
    name: '电影日记',
    text: '从大学看到工作，68影院陪伴我快五年了。看着片库从小几千到现在的五万部，真的感动。希望68影院越来越好！',
    time: '1 天前',
    avatar: 'ri-user-3-fill',
    color: 'bg-primary-100 text-primary-600',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            影迷心声
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            听听来自真实影迷的真实评价
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${c.color}`}>
                  <i className={`${c.avatar} text-lg`}></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}